import React from 'react';

const EventDetection = () => {
  return(
    <article id="event-detection">
      <h1 className="space-left bold">Event Detection</h1>
      <section>
        <h2>Breathing & Heart Rates</h2>
        <p>
          The heart rate and breathing rate data are presented in beats per minute and breaths per
          minute (both abbreviated to BPM on the display), respectively. Each of these data is then
          interpreted to be one of VERY LOW, LOW, GOOD, HIGH, and VERY HIGH, depending on the baby’s
          age. The baby/consumer’s age can be set for the product. The interpretation is made
          according to this
          <cite>
            <a href="./data/PediatricHealthDataRange.pdf" target="_blank" rel="noreferrer"> chart </a>
          </cite>.
          Readings from the SmartCrib prototype are only valid for babies under 4 years (48 months)
          of age. The interpretation is output onto the display, accompanied by either a
          <span role="img" aria-label="“sad” face"> 😞 </span> (if the reading is VERY LOW or VERY HIGH),
          a <span role="img" aria-label="“neutral” face"> 😐 </span> (if the reading is LOW or HIGH),
          or a <span role="img" aria-label="“happy” face"> 🙂 </span> (if the reading is GOOD).
        </p>
        <p>
          SmartCrib prototype has two Wi-Fi enabled functionalities: sending alerts via Slack and
          uploading data to a cloud server. We use the Adafruit IO cloud server.
          SmartCrib prototype is equipped with a Adafruit Feather M0 Wi-Fi shield, and uses the
          Arduino Wi-Fi101 library to communicate with the Adafruit and Slack servers.
          In the event of heart rate or breathing reaching levels that are VERY LOW, or VERY HIGH.
          SmartCrib prototype will notify the user via the Slack bot until the system is either
          turned off or the issue is resolved.
        </p>
        <p>
          To use the current prototype, users must make a free account with Adafruit IO and create
          their own feeds online. This is not an ideal functionality. In the future, an optimization
          would be to have the account and feeds setup for the user prior. In addition,
          users must create a Slack bot, download it to their own Slack interface, and write in the
          Slack bot key as a macro. The Slack bot will be published and this process will be made
          automatic if the project were to continue.
        </p>
      </section>
      <section>
        <h2>Noise & Motion Levels</h2>
        <article>
          <p>
            Data from the sound and HC SR501 motion sensors are polled at a rate of 22 Hz. The data
            from these sensors are measured over a period of 60 seconds because the data extracted
            from the sensors is digital data. When the sensor reads a high signal then a count for
            that sensor is incremented and if the count exceeds the designated sound limit then the
            sound alarm is triggered, but if the system exceeds 60 seconds before the sound limit is
            reached then the sound count will reset. This allows the SmartCrib to only trigger the
            sound alarm when there is an extended period of sound and motion coming from the child
            which in most cases would signify that the child is awake and crying.
          </p>
          <p>
          The HC SR501 motion sensor and the sound sensors both use potentiometers to how much data
          the sensor is able to receive.  For the HC SR501 motion sensor, there are two
          potentiometers. One is for the range of the sensor, and the other is to set how long the
          sensor will remain high after the sensor is triggered. The range potentiometer is set to
          its minimum range which allows the sensor a range of three meters. This is because the
          sensor is meant to only monitor the baby and we do not want to catch any extraneous
          movement around the room. The timer potentiometer is also set to the minimum range which
          means that the sensor remains high for only three seconds. This is to allow the most data
          points to be polled to get an accurate representation on how often the child is moving.
          The sound sensors potentiometer controls the sensitivity of the sound sensor. This
          potentiometer is set to one notch above the horizontal level on the sensor. This allows
          the sensor to be sensitive enough to allow us to catch any sound coming from the child.
          </p>
        </article>
      </section>
      <p className="align-center">
        <strong>*We only tested the prototype on ourselves. No babies are involved in testing this prototype.</strong>
      </p>
      <p className="align-center">
        Please see
        <a href="./data/CSE475Report.pdf" target="_blank" rel="noreferrer"> report </a>
        for more details on implementation.
      </p>
      <p id="to-top">
        <a href="#event-detection"> Back to Top </a>
      </p>
    </article>
  );
}

export default EventDetection;
